<template>
  <svg :width="`${size}px`" :height="`${size}px`" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>2E17E2E9-B51E-4EE2-A36F-746F3A8C5A23</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Freelance-Tasks---Pending" transform="translate(-1030.000000, -382.000000)">
        <g id="List" transform="translate(370.000000, 374.000000)">
          <g id="Variables/Icon/Play" transform="translate(660.000000, 8.000000)" filter="url(#filter-1)">
            <g id="Icon" fill="#000000" fill-rule="nonzero">
              <path d="M21,21.82 L21,10.18 L17.68,10.18 L17.68,21.82 L21,21.82 Z M14.32,21.82 L14.32,10.18 L11,10.18 L11,21.82 L14.32,21.82 Z" id=""></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PauseIcon',

  props: {
    size: {
      required: false,
      default: 32
    }
  }
};
</script>

<style scoped>

</style>
